import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.toggleAdditionalInfoForDeliveryMethod()
  }

  toggleAdditionalInfoForDeliveryMethod () {
    if (this.emailAndSmsSelected) {
      this.additionalInfoSmsAndEmail.show()
    } else {
      this.additionalInfoSmsAndEmail.hide()
    }
  }

  get emailAndSmsSelected () {
    return $('setting_settings_invoice_delivery_method_email_and_sms').checked
  }

  get additionalInfoSmsAndEmail () {
    return $('additional-info-sms-and-email')
  }
}
